import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

/**
 * AskedOfYou — "Lucas asked you about Maris", at the top of a landing page.
 *
 * A person who was asked something should not have to keep a link. Reads
 * GET /me/interviews (invited or active, mine only) and renders one line per
 * interview with Start or Continue. Renders nothing when there is nothing —
 * so it can sit on every landing page without ever being noise (Plan D).
 */
export default function AskedOfYou() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    let live = true;
    fetch("/api/me/interviews")
      .then(r => (r.ok ? r.json() : []))
      .then(d => { if (live) setRows(Array.isArray(d) ? d : []); })
      .catch(() => { if (live) setRows([]); });
    return () => { live = false; };
  }, []);

  if (!rows || rows.length === 0) return null;
  return (
    <section style={s.wrap} aria-label="Asked of you">
      {rows.map(r => {
        const started = r.status === "active";
        const who = r.coordinator_name || "Your coordinator";
        return (
          <div key={r.interview_id} style={s.row}>
            <div style={s.text}>
              <p style={s.line}>
                <strong>{who}</strong> asked you about <strong>{r.client_name || "someone"}</strong>
                <span style={s.meta}> · about 10 minutes{started && r.progress?.total ? ` · ${r.progress.answered} of ${r.progress.total} done` : ""}</span>
              </p>
              {r.note && <p style={s.note}>“{r.note}”</p>}
            </div>
            <Link to={`/clients/${r.client_id}/interviews/${r.interview_id}/session`} style={s.btn}>
              {started ? "Continue" : "Start"}
            </Link>
          </div>
        );
      })}
    </section>
  );
}

const s = {
  wrap: { display: "flex", flexDirection: "column", gap: 8, margin: "0 0 var(--space-6)" },
  row:  { display: "flex", alignItems: "center", gap: "var(--space-4)", padding: "var(--space-4)", background: "var(--color-accent-subtle)", border: "1px solid var(--color-accent)", borderRadius: "var(--radius-lg)", flexWrap: "wrap" },
  text: { flex: 1, minWidth: 200, display: "flex", flexDirection: "column", gap: 2 },
  line: { fontSize: "var(--text-base)", color: "var(--color-text-primary)", margin: 0 },
  meta: { fontSize: "var(--text-sm)", color: "var(--color-text-secondary)" },
  note: { fontFamily: "var(--font-serif)", fontSize: "var(--text-sm)", color: "var(--color-text-secondary)", margin: 0 },
  btn:  { fontSize: "var(--text-sm)", fontWeight: "var(--weight-medium)", background: "var(--color-accent)", color: "var(--color-text-on-accent)", textDecoration: "none", borderRadius: "var(--radius-md)", padding: "10px 18px", whiteSpace: "nowrap" },
};
